import { Injectable } from '@angular/core';
import { ICustomQuestionnaire } from '../../setups/models/questionnaire.interface';
import { ISkincareQuestion } from '../../questionario-skincare/models/skincare-question.interface';
import { IServerCatalogItem } from '../models/catalog';

@Injectable({
  providedIn: 'root'
})
export class CatalogoProdutosQuestionMapperService {
  private readonly answerLabelById = new Map<string, string>();

  clearCachedAnswerLabels(): void {
    this.answerLabelById.clear();
  }

  cacheQuestionnaireAnswerLabels(questionnaires: ICustomQuestionnaire[]): void {
    this.answerLabelById.clear();

    questionnaires.forEach((questionnaire) => {
      (questionnaire.questions || []).forEach((question) => {
        (question.answers || []).forEach((answer) => {
          const answerId = String(answer?.id || '').trim();
          const answerLabel = String(answer?.answer || '').trim();
          if (answerId && answerLabel) {
            this.answerLabelById.set(answerId, answerLabel);
          }
        });
      });
    });
  }

  mapServerAnswersByQuestionId(
    item: IServerCatalogItem,
    questions: ISkincareQuestion[]
  ): { [questionId: string]: string[] } {
    const optionTextById = this.buildOptionTextByIdMap(questions);
    const answersByQuestionId: { [questionId: string]: string[] } = {};

    Object.entries(item.questionAnswerIds || {}).forEach(([questionId, answerIds]) => {
      if (!Array.isArray(answerIds)) {
        return;
      }

      const resolvedTexts = answerIds
        .map((answerId) => optionTextById.get(String(answerId)))
        .filter((text): text is string => Boolean(text));

      answersByQuestionId[questionId] = resolvedTexts;
    });

    return answersByQuestionId;
  }

  private buildOptionTextByIdMap(questions: ISkincareQuestion[]): Map<string, string> {
    const optionTextById = new Map<string, string>();

    (questions || []).forEach((question) => {
      (question.options || []).forEach((option) => {
        optionTextById.set(String(option.id), option.text);
      });
    });

    return optionTextById;
  }
}
